<primecontrol-loading-spinner></primecontrol-loading-spinner>

<primecontrol-side-bar
  [items]="sideBarItems()"
  [title]="sidebarTitle()"
  [externalOpen]="mobileMenuOpen()"
  [userName]="userName"
  [userEmail]="user?.email ?? ''"
  (signOut)="signOut()"
  (toggle)="mobileMenuOpen.set($event)"
  (pinChange)="sidebarPinned.set($event)"
></primecontrol-side-bar>

<!-- Mobile backdrop while the sidebar is open -->
@if (mobileMenuOpen()) {
  <div class="fixed inset-0 bg-black/50 z-[90] md:hidden" (click)="mobileMenuOpen.set(false)"></div>
}

<div
  class="relative flex flex-col flex-auto min-w-0 min-h-0 h-full overflow-y-auto bg-default pc-page-gradient pc-shell-ground sm:transition-[margin-left] sm:duration-300"
  [style.margin-left]="contentMarginLeft()"
>
  <!-- Header: floating glass bar; content scrolls behind it -->
  <div
    class="absolute top-2 left-2 right-2 h-14 z-49 flex items-center px-4 md:px-6 print:hidden rounded-2xl nav-bar-floating backdrop-blur-2xl backdrop-saturate-150"
  >
    <div class="flex items-center w-full">
      @if (isScreenSmall()) {
        <button primecontrolIconButton (click)="mobileMenuOpen.set(!mobileMenuOpen())">
          <primecontrol-svg-icon [svgIcon]="'heroicons_outline:menu'"></primecontrol-svg-icon>
        </button>
      }

      <a href="/" [ngClass]="isScreenSmall() ? 'px-4 md:px-6' : 'px-0 md:px-2'">
        <img class="w-auto h-auto max-w-50 max-h-10" [src]="logo" alt="Logo" />
      </a>
    </div>
    <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
      <notifications></notifications>
      <primecontrol-translations></primecontrol-translations>
      <div class="flex items-center justify-between w-full">
        <user [showAvatar]="false"></user>
      </div>
    </div>
  </div>

  <div class="flex flex-col flex-auto">
    <router-outlet class="ng-start-inserted"></router-outlet>
  </div>
</div>
